import { render, staticRenderFns } from "./BannerEgressos.vue?vue&type=template&id=346e3875&scoped=true&lang=pug&"
import script from "./BannerEgressos.vue?vue&type=script&lang=js&"
export * from "./BannerEgressos.vue?vue&type=script&lang=js&"
import style0 from "./BannerEgressos.styl?vue&type=style&index=0&id=346e3875&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e3875",
  null
  
)

export default component.exports